<template>
  <div>
    <header data-v-633bfeb4="">
      <!-- <img
        data-v-633bfeb4=""
        src="./views/img/office-web-back.png"
        class="logo"
      /> -->
      <div class="logo-div" style="max-width: 280px">
        <div class="logo-div-title">长安融资租赁有限公司</div>
        <div class="logo-div-en-title">Changan Financial Leasing Co., Ltd.</div>
      </div>
      <ul data-v-633bfeb4="" class="navigator-bar">
        <li
          data-v-633bfeb4=""
          v-for="item in navList"
          :key="item.url"
          :class="`navigator-tab ${getIsActive(item) ? 'active' : ''}`"
        >
          <div
            v-if="item.type === 'select'"
            class="a-select"
            @click="handleShow()"
            tabindex="0"
            @blur="handleBlur"
          >
            {{ item.name }}<span class="caret"></span>
            <section v-if="showList === 1" class="ul-section">
              <div
                :class="`b-d ${currentUrl === '/servicestop' ? 'active' : ''}`"
                @click.stop="handleUrl('/servicestop')"
              >
                服务暂停通知
              </div>
              <div
                :class="`b-d ${
                  currentUrl === '/costdisclosure' ? 'active' : ''
                }`"
                @click.stop="handleUrl('/costdisclosure')"
              >
                费用公示
              </div>
              <div
                :class="`${currentUrl === '/consultation' ? 'active' : ''}`"
                @click.stop="handleUrl('/consultation')"
              >
                征信异议处理
              </div>
            </section>
          </div>
          <sapn v-else class="a-link" @click="handleUrl(item.url)">{{
            item.name
          }}</sapn>
        </li>
      </ul>
    </header>
    <router-view />
    <footer data-v-71c985c1="">
      <div data-v-71c985c1="" class="left-part">
        <div data-v-71c985c1="" class="info">
          <div data-v-71c985c1="" class="info-item">
            <i data-v-71c985c1="" class="icon-phone"></i>
            <span data-v-71c985c1="">Tel：400-023-6888</span>
          </div>
          <div data-v-71c985c1="" class="info-item">
            <i data-v-71c985c1="" class="icon-email"></i>
            <span data-v-71c985c1="">投诉邮箱：bzrzzlts@bzrzzl.com</span>
          </div>
          <div data-v-71c985c1="" class="info-item">
            <i data-v-71c985c1="" class="icon-phone"></i>
            <span data-v-71c985c1="">投诉电话：400-023-6888</span>
          </div>
          <div data-v-71c985c1="" class="info-item">
            <i data-v-71c985c1="" class="icon-email"></i>
            <span data-v-71c985c1="">客服邮箱：bzrzzlkf@upi.hk.cn</span>
          </div>
          <div data-v-71c985c1="" class="info-item">
            <i data-v-71c985c1="" class="icon-address"></i>
            <span data-v-71c985c1="">Ad：重庆市江北区永平门街14号21-1</span>
            <!-- <br data-v-71c985c1="" />
            <span data-v-71c985c1="" style="padding-left: 61px"
              >重庆市江北区江北嘴金融城2号T3栋21层</span
            > -->
          </div>
        </div>
        <div data-v-71c985c1="" class="footer-text">
          <span data-v-71c985c1="">版权所有©长安融资租赁有限公司</span>
          <a
            data-v-71c985c1=""
            target="_blank"
            href="http://www.beian.gov.cn/"
            style="color: deepskyblue"
            ><i data-v-71c985c1="" class="icon-beian"></i>渝公网安备
            50010502002111 号
          </a>
          <a
            data-v-71c985c1=""
            target="_blank"
            href="https://beian.miit.gov.cn"
            style="color: deepskyblue; margin: 10px 30px"
            ><i data-v-71c985c1="" class=""></i>渝ICP备2024036402号
          </a>
        </div>
      </div>
    </footer>
    <div class="confirm-dialog" v-show="actFlag">
      <div class="dialog-header">
          <div class="dialog-title">温馨提示</div>
          <!-- <button class="close-btn" @click="handleUrl('/consultation')">×</button> -->
      </div>
      <div class="dialog-body">
          <div class="warning-icon">!</div>
          <div class="dialog-text">【客户服务热线、微信服务号】服务暂停通知！</div>
      </div>
      <div class="dialog-footer">
          <!-- <button class="btn-cancel">取消</button> -->
          <button class="btn-confirm" @click="handleAct('/servicestop')">查看详情</button>
      </div>
  </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
const STORAGE_KEY = 'dialog_seen_20261017';

export default {
  name: "App",
  components: {},
  data() {
    return {
      currentUrl: "/index",
      showList: 0,
      actFlag: false,
      navList: [
        { url: "/index", name: "首页" },
        { url: "/about-us", name: "关于我们" },
        { url: "/business", name: "业务介绍" },
        { url: "/job", name: "招贤纳士" },
        { url: "/advantage", name: "企业优势" },
        {
          url: "/",
          name: "客户告知",
          type: "select",
          urlList: ["/servicestop", "/costdisclosure", "/consultation"],
        },
        {
          url: "/info-overview",
          name: "信息披露",
          urlList: ["/info-overview-detail"],
        },
      ],
    };
  },
  created() {},
  mounted() {
    if (location.hash === "#/index") {
      const endTime = new Date('2026-10-17 08:30:00').getTime();
      const now = Date.now();
      // localStorage key，标记用户已经看过弹窗
      // 判断逻辑：1、当前时间小于截止时间；2、本地没有看过标记 → 才展示弹窗
      if(now < endTime && !localStorage.getItem(STORAGE_KEY)){
          this.actFlag = true;
      }
    }
    if (location.hash === "#/advantage") {
      setTimeout(() => {
        window.scrollTo({
          top: 1630,
          behavior: "smooth", // 平滑滚动
        });
      }, 100);
    }
  },
  watch: {
    // 监听路由对象$route的变化
    $route: {
      handler: function (to, from) {
        // 路由发生变化时执行的代码
        this.currentUrl = to.path;
        console.log("this.currentUrl=", this.currentUrl);
        if (this.currentUrl === "/advantage") {
          setTimeout(() => {
            window.scrollTo({
              top: 1630,
              behavior: "smooth", // 平滑滚动
            });
          }, 100);
        } else {
          window.scrollTo({
            top: 0,
            behavior: "smooth", // 平滑滚动
          });
        }
      },
      // 设置为深度监听
      deep: true,
    },
  },
  methods: {
    handleUrl(url) {
      this.$router.push(url);
      this.showList = 0;
    },
    handleAct(url){
      this.actFlag = false;
      localStorage.setItem(STORAGE_KEY, '1');
      this.$router.push(url);
      this.showList = 0;
    },
    handleShow() {
      this.showList = 1;
    },
    getIsActive(item) {
      if (item.url === this.currentUrl && !item.activeUrl) {
        return true;
      } else if (item.urlList && item.urlList.includes(this.currentUrl)) {
        return true;
      }
      return false;
    },
    handleBlur() {
      this.showList = 0;
      // setTimeout(()=>{
      // }, 150)
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  width: 1024px;
  margin: 0 auto;
}

body,
html,
div,
ul,
li {
  margin: 0;
  padding: 0;
}

li {
  list-style-type: none;
}

div {
  box-sizing: border-box;
}

#my-toast {
  position: fixed;
  z-index: 99999;
  top: 65vh;
  width: 100%;
  text-align: center;
  transition: all 0.3s;
}

#my-toast div {
  background: rgba(0, 0, 0, 0.6);
  color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  min-width: 150px;
  display: inline-block;
  border-radius: 8px;
}

header[data-v-633bfeb4] {
  position: fixed;
  top: 0;
  z-index: 10;
  background: #fff;
  width: 1024px;
  height: 62px;
  /* box-shadow: 0 0 4px rgba(0,0,0, .2); */
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.logo[data-v-633bfeb4] {
  position: absolute;
  max-width: 307px;
  height: 42px;
  top: 12px;
}
.logo-div {
  max-width: 300px;
  position: absolute;
  top: 9px;
  margin-left: 2px;
}
.logo-div-title {
  font-weight: 600;
  font-size: 19px;
  color: #333;
  letter-spacing: 1px;
}
.logo-div-en-title {
  font-size: 12px;
  margin-top: 1px;
}
.navigator-bar[data-v-633bfeb4] {
  position: absolute;
  height: 62px;
  padding-top: 15px;
  right: 10px;
}
.navigator-tab[data-v-633bfeb4] {
  cursor: pointer;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
  display: inline-block;
  margin-right: 38px;
  transition: all 0.3s;
}
.navigator-tab[data-v-633bfeb4]:hover {
  color: rgba(61, 126, 255, 0.85);
}
.navigator-tab.active[data-v-633bfeb4] {
  padding-bottom: 2px;
  border-bottom: 4px solid rgba(61, 126, 255, 1);
}

.loading-mask[data-v-75d9b2bf] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.25);
}
.loading[data-v-75d9b2bf] {
  position: absolute;
  width: 150px;
  height: 150px;
  top: calc((100vh - 150px) / 2);
  left: calc((100vw - 150px) / 2);
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
}
.leaf-box[data-v-75d9b2bf] {
  width: 120px;
  height: 120px;
  margin-left: 15px;
  position: absolute;
}
.leaf-box li[data-v-75d9b2bf] {
  width: 16px;
  height: 4px;
  background: #e9f5f2;
  position: absolute;
  top: 60px;
  left: 75px;
  transform-origin: -16px 2px;
  border-radius: 3px;
  box-shadow: 0 0 10px rgb(233, 245, 242);
}
.loading-text[data-v-75d9b2bf] {
  color: #e9f5f2;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 105px;
  opacity: 0.5;
}

footer[data-v-71c985c1] {
  position: relative;
  width: 1024px;
  height: 166px;
  background: rgba(73, 73, 73, 1);
  color: rgba(255, 255, 255, 0.78);
  box-sizing: border-box;
}
.left-part[data-v-71c985c1] {
  position: absolute;
  width: 778px;
  left: 63px;
  top: 20px;
}
.info[data-v-71c985c1] {
  width: 100%;
}
.info-item[data-v-71c985c1] {
  display: inline-block;
  width: 375px;
  font-size: 16px;
  margin-bottom: 12px;
  line-height: 34px;
}
.footer-text[data-v-71c985c1] {
  padding-top: 14px;
  border-top: 1px solid rgba(151, 151, 151, 1);
  font-size: 12px;
  margin-bottom: 20px;
}
.footer-text span[data-v-71c985c1] {
  margin-right: 25px;
}
.right-part[data-v-71c985c1] {
  position: absolute;
  right: 69px;
  top: 57px;
  font-size: 14px;
  text-align: center;
}
.qr[data-v-71c985c1] {
  width: 86px;
  height: 86px;
}
.icon-phone[data-v-71c985c1] {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACUklEQVRYR72Xz4eWURTHP1+pTUmLNkVEokT6nZohUZsW0SIp2oyiZT8Ys4hKi4xR9AdkKDFmESUios2YflGSiJG0iDZp0SbSycl9edz3ee69z/s+dXi9i3vO+X7uee49916RMTNbDuwBDgLbgWuSHufiSseVcjSzy8BpYHXFb17S3lKBnF8tgJn5TB9Ewr1cP4GVkn7kkpeM9wGY2RLgA7A2keCApCclAjmfOoA1wOdM4ISkyVzykvE6gB3Ay0zwrKRjJQI5nzoA//6vMoELktbnkpeM1wGsAr4UBC+W9KvAL+nStAusIPGopLkCv4EA3gGbMskvSLrxrwBmgaOJ5DclnR1W3OObPoF3wEs1AneBR5L8vxNrAtgIvI8UrkhysE6t8Swws2fA7oranKTRTtWbPoGLmNlF4GokuFXSmy4hUhXYCbyIxCYlTfwXgFCF+8DhiuA3YJ8k36adWO4+cAKIV/yMpOOdqKfWQKjAIsBnuyESHJM03QVEsgIBoq4nfAdGJMVbtTVTCcAywHv+5ij7a0nbWitGAVmAUIWTwO0asb/NycxW+GUVOAPMA+ckPS+BKwIIEPeAIzVJnwIOsKUy9hU4JelhDqINgN+E2xy/vwNEcrEWA4QqnAeu52YVjY9LmmqKaQUQIG4BYy0hpiSN18W0BggQvsB2tYSYltQHPhBAgPCHydKWEOskfazGDAwQIHxRlj7T/CJzKAYeCiBA+OnoPSBlC/64lfSpc4AA4Y+UmQTBfkneL/ps6Ar0MprZSNiivVuUN6M7/pP0tgnuD3mesCGx70hpAAAAAElFTkSuQmCC)
    no-repeat 0 0 / 100% 100%;
  margin-right: 5px;
}
.icon-email[data-v-71c985c1] {
  display: inline-block;
  width: 17px;
  height: 12px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAgCAYAAACGhPFEAAACyUlEQVRYR+3YS4jNYRjH8e9vQzYotw1iI+UuaiTZKNEolyYiM40pC0pGzNQoJZcy0pTbAs0wEhFC7puxQGyQFWFBRIpYWLB49EzvOb1jzsycy//MnFPe3Tn/932ez3nO+z7//zkys3HAMWAZpT+OSNoiM7sKLC99b1q429EfgLFlhL7s6HZgfRmhm+RYMzsANJQBfIOktk50gG8FWkoU/hWokXTbfWl0gK8GzgCDSwj/EqiW9DwYR/iefihpflTxBYDv8wklAL8fwJ8DeBpw2NEGvAHmSPoRLk4CTgPzBhDeLqkmKuZi4A7QkUL7tZ/AbElvA3wY0AqsHAB4s6TGCFwbLP5WF3RqToWkJ9GCo8DmfoRvk5RuCGbWBOyL8mdE+/VKSTcj+E5gb5Hhv4A6SRf6KFiPaF9XK8n3daol1gGnigR/F8AdUb4rwIoM+XpF+/xGSc1RoEqgDRiZIP4R4DeNV1Eexy/sIUefaF93SNL2KODcUPHpCcC9mg5Oda3RwD1gRi+xs0L7+rOSqiP4eOAE4G0o33FcUvqAm9lM4BrgsXsbWaM9yF1graRv/sLMBgEnvfnnod4laU9UhKXAeWBoFrFyQnu8Z8AaSa+jhL7nd2SRLDVloyT/sJ3DzHI94DmjPc9HoErS4yjxNt/7fcC/AA6+Hq3zs3Iwhw/sU/NC+8I/wCpJNyLAurBdhmRAvAjgp9F87/ve/3MdeaNTiTqfbyPIonBAJ0YSPwte4ffRPP9NuilXbZhfMNrjNEhKf8VmNtXbGDALeADsl/Q7Ap/zA50nuKDt8W/OLg84mUBmNibcmJYUAE4U7cFaJXkn6DbMbHIAVxQIThztAb2jtEi6FG2HesC7S1K/+BPZ05mK9wnwXj4FGJVAdeMQRUMn7OwS7j+6mNXttj2+A8P7K2MCeW6V7R+Q/levP+xUJVCFYobwjnRRUv1fTnJTM+obOUIAAAAASUVORK5CYII=)
    no-repeat 0 0 / 100% 100%;
  margin-right: 5px;
}
.icon-address[data-v-71c985c1] {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACe0lEQVRYR62XO49OURSGn/cHoHQJhcYU4hbD0BGJoaDBNC4lDQlmFIQghMJlJDSmxDQuDQUmETrXCUYUplEQlxI/YMmWfZIzZ/btfJ+dfMWX8653PWftddY+R7RYZrYQ2ADsBOYBc334d+AbMAo8kfS51FYlQjNbCez1v5KQEWBE0nhOnAUws6PAuZxR5PoxSedTsUkAMzsFnOwweRV2WpLzCa4ogJntAG53mbwKH5B0J+QVBPB7/uY/Ja9sekM9EQO4XtBwH4EX3n0NsDgD7JpyX1MzDcDMFgGfMmZDki7VNWY2CFzMxPVImqxrQgBJI0m5xrUExDTwEMBTYF3EJNpMlT7TvM8krc9VwJXfbUNzTUrqKWlMMyv2CFXgNzAjkGhU0q5CgFt+XDflfyTNzFXgCzA/kCjYxSEgM4s9RV8lLcgB3AW2BYzHJfUWVsDNEHd+NNc9SdtzAEPAhUiifkljKQgz2wg8jmiOSJryqIZ6IGUwIWlZBuA9sLT0BkIAs4EfiSTPgeHmbPeP3yFgbSJ2jqSfyS1wF80sdRdVvJtor/2fVZFHt54rWL3YWXAcOFPScC00JySdbepjALOAl0DR4CmAcIOpT9KvIgC/DfuBqwXmJZIDkq6FhLmDxVVhdUmGhOaVpL7Y9RzAbuBGlwB7JN3sCMBvhRsqbjZ0ssYk9acCS96KtwD3O8kObJX0oCsAX4Vh4GBLiCuS3GBKrmwFqmgzewsszxn66+8krSjRtgFYAkyUmLqzQNKHEm0xgN+Kw8CUl9FAkkFJl0uSO00rAA/xENgUSfBI0ubS5B0BeIjQV1P2hTUE1roCdRMz+/fpJmmgzV3XtX8BEHraIe8KMxsAAAAASUVORK5CYII=)
    no-repeat 0 0 / 100% 100%;
  margin-right: 5px;
}
.icon-beian[data-v-71c985c1] {
  position: relative;
  top: 4px;
  right: 6px;
  display: inline-block;
  width: 21px;
  height: 21px;
  background: url(./views/img/logo-gongan.25d3024.png) no-repeat 0 0 / 100% 100%;
}

.a-link,
.a-select {
  cursor: pointer;
  font-size: 18px;
  display: inline-block;
  color: rgba(0, 0, 0, 0.85);
  display: inline-block;
  transition: all 0.3s;
  text-decoration: none;
}
.a-link:hover,
.a-select:hover {
  color: rgba(61, 126, 255, 0.85);
}

.ul-section {
  color: rgba(0, 0, 0, 0.85);
  position: absolute;
  background: #fff !important;
  margin-top: 12px;
  border-radius: 4px;
  width: 160px;
  border: 1px solid #d6d6d6 !important;
  // transition: max-height 0.5s ease-out;
  // overflow: hidden;
  div {
    line-height: 38px;
    text-align: center;
  }
  div:hover {
    color: rgba(61, 126, 255, 0.85);
  }
  .active {
    color: rgba(61, 126, 255, 0.85);
  }
  .b-d {
    border-bottom: 1px solid #d6d6d6 !important;
  }
}
.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

/* 弹窗容器：固定右下角 */
.confirm-dialog {
            position: fixed;
            right: 30px;
            bottom: 30px;
            width: 420px;
            background: #ffffff;
            border-radius: 8px;
            box-shadow: 0 2px 16px rgba(0,0,0,0.15);
            overflow: hidden;
            z-index: 9999;
        }
        .dialog-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 18px;
        }
        .dialog-title {
            font-size: 20px;
            font-weight: bold;
            color:#1f2329;
        }
        .close-btn {
            width:24px;
            height:24px;
            border:none;
            background: transparent;
            font-size:20px;
            color:#909399;
            cursor: pointer;
        }
        .dialog-body {
            padding: 8px 18px 18px;
            display:flex;
            align-items:center;
            gap: 3px;
        }
        .warning-icon {
            width:24px;
            height:24px;
            border-radius:50%;
            background:#e6a23c;
            color:#fff;
            font-size:20px;
            display:flex;
            align-items:center;
            justify-content:center;
            flex-shrink:0;
        }
        .dialog-text {
            font-size:16px;
            color:#4e5969;
        }
        .dialog-footer {
            display:flex;
            justify-content:flex-end;
            gap:12px;
            padding:0 18px 18px;
        }
        .btn-cancel {
            padding:7px 20px;
            border:1px solid #dcdfe6;
            background:#fff;
            border-radius:6px;
            font-size:15px;
            cursor:pointer;
            color:#606266;
        }
        .btn-confirm {
            padding:7px 20px;
            border:none;
            background:#4096ff;
            color:#fff;
            border-radius:6px;
            font-size:15px;
            cursor:pointer;
        }
</style>
